import React, { useEffect, useState } from "react";
import withUserData from "../HOK/withUserData";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase"; // ✅ перевір шлях (у тебе в order так)

import Order from "./order";
import PartnerOrder from "./PartnerOrder";

function OrderEntry({ setLogin, user, discountInHok }) {
  const [realUser, setRealUser] = useState(null);
  const [realLoading, setRealLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    (async () => {
      // якщо гість / auth ще не готовий
      if (!user?.uid) {
        if (!alive) return;
        setRealUser(null);
        setRealLoading(false);
        return;
      }

      setRealLoading(true);

      // 1) спроба users/{uid}
      try {
        const directRef = doc(db, "users", user.uid);
        const snap = await getDoc(directRef);

        if (snap.exists()) {
          if (!alive) return;
          setRealUser({ uid: user.uid, ...snap.data() });
          setRealLoading(false);
          return;
        }
      } catch (e) {
        // йдемо у fallback
      }

      // 2) fallback: where("uid"=="user.uid")
      try {
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const qs = await getDocs(q);

        if (!alive) return;

        if (!qs.empty) {
          const d = qs.docs[0];
          setRealUser({ uid: user.uid, ...d.data() });
        } else {
          setRealUser(null);
        }
      } catch (e) {
        console.error("Не вдалося отримати realUser:", e);
        if (!alive) return;
        setRealUser(null);
      } finally {
        if (!alive) return;
        setRealLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [user?.uid]);

  // ✅ Лоадер тільки поки реально вантажимо (або auth ще не дав uid)
  if (!user?.uid || realLoading) {
    return <div style={{ padding: 24 }}>Завантаження...</div>;
  }
  console.log("realUser", realUser);

  const isPartner = realUser?.category === "Бізнес-партнер";

  return isPartner ? (
    <PartnerOrder
      setLogin={setLogin}
      user={user} // auth user
      realUser={realUser} // ✅ реальний користувач з Firestore
      discountInHok={discountInHok}
    />
  ) : (
    <Order
      setLogin={setLogin}
      user={user}
      realUser={realUser}
      discountInHok={discountInHok}
    />
  );
}

export default withUserData(OrderEntry);
